<template>
  <!-- top level menu bar -->
  <q-bar style="min-width: 250px;" class="bg-white">
    <div class="text-primary" style="white-space: nowrap">
      Get Started
    </div>
    <q-space></q-space>
  </q-bar>
  <q-separator></q-separator>

  <p class="text-h6 q-mt-md text-primary">Explore Florida Freshwater</p>
  <p class="">
    With thousands of lakes, scenic rivers, and more springs than anywhere else
    in the world, freshwater is an integral part of Florida’s iconic landscape.
    Yet, in the state with the third largest population in the country - over 20
    million people - freshwater cannot be taken for granted. The mapping tools
    below allow you to explore data relevant to Florida’s freshwater resources.
  </p>
  <div class="row q-mt-xl">
    <div class="col-9">
      <p class="text-subtitle2 text-bold text-primary">Sedimentation</p>
    </div>
    <div class="col-3">
      <q-btn
        to="/sedimentation"
        text-color="white"
        unelevated
        size="sm"
        color="primary"
        >GO to</q-btn
      >
    </div>
  </div>

  <p class="" v-if="showMore == false">
    The Yellow River is one of 3 large rivers that flow into Pensacola Bay. An
    assessment of the Yellow River watershed identified 140 impaired...
    <span
      ><q-btn
        id="morebtn"
        flat
        no-caps
        size="sm"
        class="q-pa-xs q-ma-none"
        dense
        color="primary"
        @click="showMore = true"
        >More</q-btn
      ></span
    >
  </p>
  <p class="" v-if="showMore == true">
    The Yellow River is one of 3 large rivers that flow into Pensacola Bay. An
    assessment of the Yellow River watershed identified 140 impaired river
    corridor sites and identified moderate or high degrees of sedimentation risk
    at 339 unpaved road crossings. Use this app to examine the assessment data.
    Read a
    <a
      color=""
      href="https://maps.freshwaternetwork.org/florida/docs/YR%20Summary%20formatted%2014Dec2018.pdf"
      target="_blank"
      >short summary</a
    >
    of the project or the
    <a
      color=""
      href="https://maps.freshwaternetwork.org/florida/docs/PS_FINAL_REPORT.pdf"
      target="_blank"
      >full report</a
    >

    <q-img src="img/GS_sediment.png"></q-img>
    <span
      ><q-btn
        id="morebtn"
        flat
        no-caps
        size="sm"
        class="q-pa-xs q-ma-none"
        dense
        color="primary"
        @click="showMore = false"
        >show less</q-btn
      ></span
    >
  </p>

  <div class="row q-mt-xl">
    <div class="col-9">
      <p class="text-subtitle2 text-bold text-primary ">Aquifers</p>
    </div>
    <div class="col-3">
      <q-btn
        to="/aquifers"
        text-color="white"
        unelevated
        size="sm"
        color="primary"
        >GO to</q-btn
      >
    </div>
  </div>
  <p class="" v-if="showMore1 == false">
    The Floridan aquifer is the major source of drinking water for Florida. The
    Howard T. Odum Florida Springs Institute completed a study for T...
    <span
      ><q-btn
        id="morebtn"
        flat
        no-caps
        size="sm"
        class="q-pa-xs q-ma-none"
        dense
        color="primary"
        @click="showMore1 = true"
        >More</q-btn
      ></span
    >
  </p>
  <p class="" v-if="showMore1 == true">
    The Floridan aquifer is the major source of drinking water for Florida. The
    Howard T. Odum Florida Springs Institute completed a study for The Nature
    Conservancy that looked at the Florida Springs region and developed a map of
    how water use and nitrogen loads vary across it. Use this app to examine the
    results of the analysis. Read a
    <a
      color=""
      href="https://maps.freshwaternetwork.org/florida/docs/AFA%20Summary%20formatted%2014Dec2018.pdf"
      target="_blank"
      >short summary</a
    >
    of the project or the
    <a
      color=""
      href="https://maps.freshwaternetwork.org/florida/docs/AFA%20Final%20Report%20web.pdf"
      target="_blank"
      >full report</a
    >
    <q-img src="img/GS_aquifer_resize.png"></q-img>
    <span
      ><q-btn
        id="morebtn"
        flat
        no-caps
        size="sm"
        class="q-pa-xs q-ma-none"
        dense
        color="primary"
        @click="showMore1 = false"
        >show less</q-btn
      ></span
    >
  </p>
</template>

<script>
export default {
  name: 'about',
  components: {},
  activated() {
    this.$store.commit('updateCurrentWebMap', 'about');
  },
  data() {
    return {
      showMore: false,
      showMore1: false,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#print-header {
  position: absolute;
  top: 0px;
  height: 30px;
}
#print-footer {
  position: absolute;
  bottom: 0px;
  height: 30px;
}
#print-map {
  position: absolute;
  top: 30px;
  height: 500px;
}
</style>
